module.exports = __webpack_public_path__ + "media/2.738cdb79.mp3";